import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import style from './table.sass'

class Table extends Component {
  render() {
    return(
      <section styleName='wrapper'>
        <div className='landing-container' styleName='container'>
          <table>
            <thead>
              <tr>
                <td></td>
                <td><img src='/img/landing/pricing/table-icon-1.png' alt=''/> Lite</td>
                <td><img src='/img/landing/pricing/table-icon-2.png' alt=''/> Professional</td>
                <td><img src='/img/landing/pricing/table-icon-3.png' alt=''/> Premium</td>
                <td><img src='/img/landing/pricing/table-icon-4.png' alt=''/> Enterprise</td>
              </tr>
              <tr>
                <th styleName='price-heading'>Pricing<br/> Plans</th>
                <th>Free</th>
                <th>$29 <span>Monthly</span></th>
                <th>$69 <span>Monthly</span></th>
                <th>Custom</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td><span>Algorithms</span></td>
                <td>2</td>
                <td>10</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <td><span>Screeners</span></td>
                <td>1</td>
                <td>5</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <td><span>Paper Trading</span></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
              </tr>
              <tr>
                <td><span>Securities</span></td>
                <td>Stocks</td>
                <td>Stocks, CryptoCurrency</td>
                <td>Stocks, CryptoCurrency</td>
                <td>Stocks, CryptoCurrency</td>
              </tr>
              <tr>
                <td><span>Trigger Notification</span></td>
                <td>Email</td>
                <td>Email</td>
                <td>Email, SMS</td>
                <td>Custom</td>
              </tr>
              <tr>
                <td><span>Backtest Period</span></td>
                <td>1 year</td>
                <td>5 year or more</td>
                <td>5 year or more</td>
                <td>5 year or more</td>
              </tr>
              <tr>
                <td><span>Market Sentiment data</span></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td>Yes, additional cost</td>
                <td>Yes, additional cost</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td><span>Custom Hosting</span></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td>Dedicated virtual<br/> machine additional cost</td>
                <td>Self-hosting<br/> Available</td>
              </tr>
              <tr>
                <td></td>
                <td><Link to='/signup/plan/1'>signup</Link></td>
                <td><Link to='/signup/plan/2'>Try For Free</Link></td>
                <td><Link to='/signup/plan/3'>Try For Free</Link></td>
                <td><Link to='/free-trial'>Contact Us</Link></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    )
  }
}

export default Table
